export type Language = 'en' | 'de'

export interface TranslationKeys {
  'nav.dashboard': string
  'nav.projects': string
  'nav.configuration': string
  'nav.guide': string
  'nav.failingTests': string
  'page.dashboard': string
  'page.projects': string
  'page.configuration': string
  'page.guide': string
  'page.failingTests': string
  'button.save': string
  'button.cancel': string
  'button.create': string
  'button.delete': string
  'button.login': string
  'button.logout': string
  'button.assign': string
  'button.unassign': string
  'button.close': string
  'button.clear': string
  'button.newProject': string
  'button.addTests': string
  'button.selectAll': string
  'button.downloadData': string
  'button.selectNone': string
  'label.loading': string
  'label.testsSelected': string
  'label.projectName': string
  'label.description': string
  'label.filterByPackage': string
  'label.filterByTestName': string
  'label.allPackages': string
  'placeholder.testNameFilter': string
  'label.startDate': string
  'label.fteCount': string
  'label.theme': string
  'label.accentColor': string
  'label.hours': string
  'label.gap': string
  'label.test': string
  'label.status': string
  'label.actions': string
  'label.buildId': string
  'label.date': string
  'label.timeRange': string
  'label.lastNDays': string
  'label.total': string
  'label.passed': string
  'label.failed': string
  'label.error': string
  'label.showFailingTests': string
  'label.skipped': string
  'label.passRate': string
  'label.totalTests': string
  'label.unassignedTests': string
  'label.chooseProject': string
  'label.staleTests': string
  'label.duration': string
  'label.inBuild': string
  'label.unassigned': string
  'label.staleThreshold': string
  'label.lastSeenBuildsAgo': string
  'label.effortTracking': string
  'label.from': string
  'label.to': string
  'button.addEffort': string
  'empty.noEffortEntries': string
  'misc.effortHelp': string
  'empty.noStaleTests': string
  'empty.noFailingTests': string
  'misc.deleting': string
  'confirm.deleteStale': string
  'label.failingTests': string
  'label.skippedTests': string
  'label.passingTests': string
  'label.avgHoursPerTest': string
  'label.projectedRemainingHours': string
  'label.projectedTotalHours': string
  'label.fteLabel': string
  'label.effectiveFte': string
  'label.activeProjects': string
  'label.projectedEnd': string
  'label.project': string
  'label.endDate': string
  'label.effortToFinish': string
  'label.featureCompleteness': string
  'label.testsInProject': string
  'label.projectOverview': string
  'label.totalHours': string
  'label.language': string
  'status.passed': string
  'status.failed': string
  'status.error': string
  'status.skipped': string
  'status.unknown': string
  'status.featureComplete': string
  'empty.noBuilds': string
  'warning.staleBuildHistory': string
  'warning.staleBuildHistoryDetail': string
  'empty.noTests': string
  'empty.noUnassignedTests': string
  'empty.noProjects': string
  'empty.noTestsTagged': string
  'empty.noTestData': string
  'empty.selectProject': string
  'error.failedToRemoveTest': string
  'error.failedToRemoveTests': string
  'error.failedToCreateProject': string
  'error.failedToDeleteProject': string
  'error.failedToFetchTests': string
  'error.failedToLoadTests': string
  'error.failedToUpdateSettings': string
  'error.failedToClearBudget': string
  'error.failedToSaveBudget': string
  'error.failedToUpdateStartDate': string
  'error.failedToClearStartDate': string
  'error.invalidHours': string
  'error.fteMustBePositive': string
  'error.failedToDownloadData': string
  'error.projectNotFound': string
  'confirm.deleteProject': string
  'confirm.clearBudget': string
  'component.recentBuilds': string
  'component.statusDistribution': string
  'component.testEvolution': string
  'component.fteSettings': string
  'component.testEffortMaintenance': string
  'component.addTestsToProject': string
  'component.globalAvgEffort': string
  'component.themeSettings': string
  'theme.system': string
  'theme.light': string
  'theme.dark': string
  'color.blue': string
  'color.purple': string
  'color.green': string
  'color.orange': string
  'color.pink': string
  'guide.title': string
  'guide.introduction': string
  'guide.introText': string
  'guide.coreConcepts': string
  'guide.projects': string
  'guide.projectsDesc': string
  'guide.testsAndAcceptance': string
  'guide.testsAndAcceptanceDesc': string
  'guide.statusPassedDesc': string
  'guide.statusFailedDesc': string
  'guide.statusSkippedDesc': string
  'guide.statusErrorDesc': string
  'guide.featureCompletenessTitle': string
  'guide.featureCompletenessDesc': string
  'guide.featureCompletenessFormula': string
  'guide.featureCompletenessNote': string
  'guide.workflow': string
  'guide.step1Title': string
  'guide.step1Desc': string
  'guide.step2Title': string
  'guide.step2Desc': string
  'guide.step3Title': string
  'guide.step3Desc': string
  'guide.step4Title': string
  'guide.step4Desc': string
  'guide.projectionFormulas': string
  'guide.avgHoursTitle': string
  'guide.avgHoursDesc': string
  'guide.avgHoursFormula': string
  'guide.avgHoursNote': string
  'guide.projectedTotalTitle': string
  'guide.projectedTotalDesc': string
  'guide.projectedTotalFormula': string
  'guide.projectedTotalNote': string
  'guide.endDateTitle': string
  'guide.endDateDesc': string
  'guide.dailyCapacityFormula': string
  'guide.daysNeededFormula': string
  'guide.endDateFormula': string
  'guide.endDateNote': string
  'guide.quickLinks': string
  'guide.viewTestTrends': string
  'guide.monitorCompletion': string
  'guide.manageProjects': string
  'guide.inspectFailures': string
  'misc.creating': string
  'misc.saving': string
  'misc.assigning': string
  'misc.loadingProject': string
  'misc.version': string
  'misc.fteHelp': string
  'misc.testEffortDesc': string
  'misc.removeFromProject': string
  'misc.downloading': string
  'misc.globalAvgHelp': string
}

type TranslationRecord = Record<keyof TranslationKeys, string>

const en: TranslationRecord = {
  'nav.dashboard': 'Dashboard',
  'nav.projects': 'Projects',
  'nav.configuration': 'Configuration',
  'nav.guide': 'Guide',
  'nav.failingTests': 'Failing Tests',
  'page.dashboard': 'Test Dashboard',
  'page.projects': 'Projects',
  'page.configuration': 'Configuration & Budgeting',
  'page.guide': 'How It Works',
  'page.failingTests': 'Failing Tests',
  'button.save': 'Save',
  'button.cancel': 'Cancel',
  'button.create': 'Create',
  'button.delete': 'Delete',
  'button.login': 'Login',
  'button.logout': 'Logout',
  'button.assign': 'Assign',
  'button.unassign': 'Unassign',
  'button.close': 'Close',
  'button.clear': 'Clear',
  'button.newProject': 'New Project',
  'button.addTests': 'Add Tests to Project',
  'button.selectAll': 'Select All',
  'button.downloadData': 'Download Data',
  'button.selectNone': 'Select None',
  'label.loading': 'Loading...',
  'label.testsSelected': '{count} selected',
  'label.projectName': 'Project name',
  'label.description': 'Description (optional)',
  'label.filterByPackage': 'Filter by Package:',
  'label.filterByTestName': 'Filter by Test Name:',
  'label.allPackages': 'All packages',
  'placeholder.testNameFilter': 'Search class or method name...',
  'label.startDate': 'Start Date:',
  'label.fteCount': 'FTE Count:',
  'label.theme': 'Theme',
  'label.accentColor': 'Accent Color',
  'label.hours': 'Hours',
  'label.gap': 'Gap %',
  'label.test': 'Test',
  'label.status': 'Status',
  'label.actions': 'Actions',
  'label.buildId': 'Build ID',
  'label.date': 'Date',
  'label.timeRange': 'Time Range',
  'label.lastNDays': 'Last {days} days',
  'label.total': 'Total',
  'label.passed': 'Passed',
  'label.failed': 'Failed',
  'label.error': 'Errors',
  'label.showFailingTests': 'Show the failing tests of this build',
  'label.skipped': 'Skipped',
  'label.passRate': 'Pass Rate',
  'label.totalTests': 'Total Tests',
  'label.unassignedTests': 'Unassigned Tests',
  'label.chooseProject': 'Choose a project…',
  'label.staleTests': 'Stale Tests',
  'label.duration': 'Duration',
  'label.inBuild': 'In build {buildId} ({date})',
  'label.unassigned': 'Unassigned',
  'label.staleThreshold': 'Not seen in the last N builds',
  'label.lastSeenBuildsAgo': 'Last seen {count} build(s) ago',
  'label.effortTracking': 'Effort Tracking',
  'label.from': 'From',
  'label.to': 'To',
  'button.addEffort': 'Add effort',
  'empty.noEffortEntries': 'No effort tracked yet.',
  'misc.effortHelp':
    'Tracked effort is added to the summed per-test effort, then divided by the number of passing tests to derive the average effort per test used for projections. Time frames may overlap.',
  'empty.noStaleTests': 'No stale tests — every test appeared recently.',
  'empty.noFailingTests': 'No failing tests — the latest build is green.',
  'misc.deleting': 'Deleting…',
  'confirm.deleteStale':
    'Delete {count} stale test(s)? This also removes their project assignments.',
  'label.failingTests': 'Failing Tests',
  'label.skippedTests': 'Skipped Tests',
  'label.passingTests': 'Passing Tests',
  'label.avgHoursPerTest': 'Avg Hours/Test',
  'label.projectedRemainingHours': 'Remaining Hours',
  'label.projectedTotalHours': 'Projected Total Hours',
  'label.fteLabel': 'FTE',
  'label.effectiveFte': '{fte} FTE (of {total})',
  'label.activeProjects': 'Active Projects',
  'label.projectedEnd': 'Projected End (from today)',
  'label.project': 'Project',
  'label.endDate': 'End Date',
  'label.effortToFinish': 'Effort to Finish',
  'label.featureCompleteness': 'Feature Completeness',
  'label.testsInProject': 'Tests in Project',
  'label.projectOverview': 'Project Overview',
  'label.totalHours': 'Total Hours',
  'label.language': 'Language',
  'status.passed': 'Passed',
  'status.failed': 'Failed',
  'status.error': 'Error',
  'status.skipped': 'Skipped',
  'status.unknown': 'Unknown',
  'status.featureComplete': 'Feature Complete',
  'empty.noBuilds': 'No builds recorded yet. Configure Jenkins webhook to start tracking.',
  'warning.staleBuildHistory': 'No build reported for {days} days (last on {date}).',
  'warning.staleBuildHistoryDetail':
    'This may signal a broken test dashboard integration - check the Jenkins webhook.',
  'empty.noTests': 'No tests found.',
  'empty.noUnassignedTests': 'All tests are assigned to a project.',
  'empty.noProjects': 'No projects yet. Create one to start tagging tests.',
  'empty.noTestsTagged': 'No tests tagged to this project yet.',
  'empty.noTestData': 'No test data available.',
  'empty.selectProject': 'Select a project to view details and manage test budgets.',
  'error.failedToRemoveTest': 'Failed to remove test',
  'error.failedToRemoveTests': 'Failed to remove tests',
  'error.failedToCreateProject': 'Failed to create project',
  'error.failedToDeleteProject': 'Failed to delete project',
  'error.failedToFetchTests': 'Failed to fetch tests',
  'error.failedToLoadTests': 'Failed to load tests',
  'error.failedToUpdateSettings': 'Failed to update settings',
  'error.failedToClearBudget': 'Failed to clear budget',
  'error.failedToSaveBudget': 'Failed to save budget',
  'error.failedToUpdateStartDate': 'Failed to update start date',
  'error.failedToClearStartDate': 'Failed to clear start date',
  'error.invalidHours': 'Please enter valid number for hours',
  'error.fteMustBePositive': 'FTE count must be greater than 0',
  'error.failedToDownloadData': 'Failed to download data',
  'error.projectNotFound': 'Project not found',
  'confirm.deleteProject': 'Are you sure you want to delete this project?',
  'confirm.clearBudget': 'Clear budget for this test?',
  'component.recentBuilds': 'Recent Builds',
  'component.statusDistribution': 'Status Distribution',
  'component.testEvolution': 'Test Evolution',
  'component.fteSettings': 'FTE Settings',
  'component.testEffortMaintenance': 'Test Effort Maintenance',
  'component.addTestsToProject': 'Add Tests to Project',
  'component.globalAvgEffort': 'Global Average Test Effort',
  'component.themeSettings': 'Theme settings',
  'theme.system': 'System',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'color.blue': 'Blue',
  'color.purple': 'Purple',
  'color.green': 'Green',
  'color.orange': 'Orange',
  'color.pink': 'Pink',
  'guide.title': 'How It Works',
  'guide.introduction': 'Introduction',
  'guide.introText':
    'This tool helps teams track project completion through acceptance tests. Projects achieve completeness by fulfilling their assigned tests, and end dates are projected based on historical effort data.',
  'guide.coreConcepts': 'Core Concepts',
  'guide.projects': 'Projects',
  'guide.projectsDesc':
    'A project represents a feature or body of work being tracked. Tests are assigned to projects to measure progress toward completion.',
  'guide.testsAndAcceptance': 'Tests & Acceptance Criteria',
  'guide.testsAndAcceptanceDesc':
    'Tests represent acceptance criteria. When a test passes, it indicates that a piece of functionality is complete. Tests can be in various states:',
  'guide.statusPassedDesc': 'Test executed successfully — contributes to completion',
  'guide.statusFailedDesc': 'Test executed but failed — indicates work needed',
  'guide.statusSkippedDesc': 'Test not yet implemented — represents future work',
  'guide.statusErrorDesc': 'Test execution error — needs investigation',
  'guide.featureCompletenessTitle': 'Feature Completeness',
  'guide.featureCompletenessDesc': "A project's feature completeness is calculated as:",
  'guide.featureCompletenessFormula': 'Feature Completeness = Passed Tests / Enabled Tests × 100%',
  'guide.featureCompletenessNote':
    'A project is considered "complete" when all enabled tests pass (100%).',
  'guide.workflow': 'Workflow',
  'guide.step1Title': 'Report Test Results',
  'guide.step1Desc':
    'Build pipelines execute acceptance tests and report results to the webhook endpoint using the provided Jenkins shell scripts (parse-surefire.sh and post-test-results.sh). Results are processed in batch to prevent data loss, and test status updates preserve any previously configured budgets and project assignments.',
  'guide.step2Title': 'Assign Tests to Projects',
  'guide.step2Desc':
    "Once tests appear in the system, assign them to projects via the Configuration page. This announces that the test is part of the project's scope.",
  'guide.step3Title': 'Set Budget Hours',
  'guide.step3Desc':
    'Optionally record the hours spent making each test pass. This data is used to calculate average effort and project end date projections.',
  'guide.step4Title': 'Track Progress',
  'guide.step4Desc':
    'Monitor project completion on the Projects dashboard. As tests pass, completion percentage increases and the projected end date adjusts.',
  'guide.projectionFormulas': 'Projection Formulas',
  'guide.avgHoursTitle': 'Average Hours per Test',
  'guide.avgHoursDesc':
    'A global metric calculated across all tests in the system, not per project:',
  'guide.avgHoursFormula': 'Average Hours = Total Budget Hours / Non-Skipped Test Count',
  'guide.avgHoursNote':
    'All non-skipped tests are used in the denominator. This is a system-wide metric reflecting the organization-wide average effort per test.',
  'guide.projectedTotalTitle': 'Projected Total Hours',
  'guide.projectedTotalDesc':
    'Estimates total effort including projected effort for remaining skipped tests:',
  'guide.projectedTotalFormula':
    'Projected Total = Total Budget Hours + (Average Hours × Skipped Test Count)',
  'guide.projectedTotalNote':
    'Only skipped (not yet started) tests are projected. Known effort from budgeted tests is preserved as-is.',
  'guide.endDateTitle': 'End Date Projection',
  'guide.endDateDesc':
    'End dates are calculated using an iterative simulation that accounts for FTE redistribution as projects complete:',
  'guide.dailyCapacityFormula':
    'Daily Capacity per Project = 7.42 hours × FTE Count / Current Active Projects',
  'guide.daysNeededFormula':
    'When a project completes, its FTE share is redistributed to remaining projects',
  'guide.endDateFormula': 'End Date = Simulation of all project completions over time',
  'guide.endDateNote':
    'The simulation divides FTE equally across active projects. As shorter projects finish first, remaining projects receive more capacity and accelerate. This produces more accurate end dates than a simple static split.',
  'guide.quickLinks': 'Quick Links',
  'guide.viewTestTrends': 'View test execution trends',
  'guide.monitorCompletion': 'Monitor project completion',
  'guide.manageProjects': 'Manage projects and assign tests',
  'guide.inspectFailures': 'Inspect the failures of the latest build',
  'misc.creating': 'Creating...',
  'misc.saving': 'Saving...',
  'misc.assigning': 'Assigning...',
  'misc.loadingProject': 'Loading project...',
  'misc.version': 'Version {version}',
  'misc.fteHelp': 'FTE count is used to calculate project end dates (37.1 hours/week per FTE)',
  'misc.testEffortDesc': 'Record effort hours and gap percentages for tests across all projects.',
  'misc.removeFromProject': 'Remove from project',
  'misc.downloading': 'Downloading...',
  'misc.globalAvgHelp':
    'System-wide average calculated as total budget hours divided by all non-skipped tests. Used for all projections.',
}

const de: TranslationRecord = {
  'nav.dashboard': 'Dashboard',
  'nav.projects': 'Projekte',
  'nav.configuration': 'Konfiguration',
  'nav.guide': 'Anleitung',
  'nav.failingTests': 'Fehlerhafte Tests',
  'page.dashboard': 'Test-Dashboard',
  'page.projects': 'Projekte',
  'page.configuration': 'Konfiguration & Budgetierung',
  'page.guide': 'So funktioniert es',
  'page.failingTests': 'Fehlerhafte Tests',
  'button.save': 'Speichern',
  'button.cancel': 'Abbrechen',
  'button.create': 'Erstellen',
  'button.delete': 'Löschen',
  'button.login': 'Anmelden',
  'button.logout': 'Abmelden',
  'button.assign': 'Zuweisen',
  'button.unassign': 'Entfernen',
  'button.close': 'Schließen',
  'button.clear': 'Leeren',
  'button.newProject': 'Neues Projekt',
  'button.addTests': 'Tests zum Projekt hinzufügen',
  'button.selectAll': 'Alle auswählen',
  'button.downloadData': 'Daten herunterladen',
  'button.selectNone': 'Auswahl aufheben',
  'label.loading': 'Wird geladen...',
  'label.testsSelected': '{count} ausgewählt',
  'label.projectName': 'Projektname',
  'label.description': 'Beschreibung (optional)',
  'label.filterByPackage': 'Nach Paket filtern:',
  'label.filterByTestName': 'Nach Testname filtern:',
  'label.allPackages': 'Alle Pakete',
  'placeholder.testNameFilter': 'Klassen- oder Methodenname suchen...',
  'label.startDate': 'Startdatum:',
  'label.fteCount': 'VZÄ-Anzahl:',
  'label.theme': 'Design',
  'label.accentColor': 'Akzentfarbe',
  'label.hours': 'Stunden',
  'label.gap': 'Puffer %',
  'label.test': 'Test',
  'label.status': 'Status',
  'label.actions': 'Aktionen',
  'label.buildId': 'Build-ID',
  'label.date': 'Datum',
  'label.timeRange': 'Zeitraum',
  'label.lastNDays': 'Letzte {days} Tage',
  'label.total': 'Gesamt',
  'label.passed': 'Erfolgreich',
  'label.failed': 'Fehlgeschlagen',
  'label.error': 'Fehler',
  'label.showFailingTests': 'Fehlerhafte Tests dieses Builds anzeigen',
  'label.skipped': 'Übersprungen',
  'label.passRate': 'Erfolgsquote',
  'label.totalTests': 'Tests gesamt',
  'label.unassignedTests': 'Nicht zugewiesene Tests',
  'label.chooseProject': 'Projekt auswählen…',
  'label.staleTests': 'Veraltete Tests',
  'label.duration': 'Dauer',
  'label.inBuild': 'In Build {buildId} ({date})',
  'label.unassigned': 'Nicht zugeordnet',
  'label.staleThreshold': 'Nicht gesehen in den letzten N Builds',
  'label.lastSeenBuildsAgo': 'Zuletzt gesehen vor {count} Build(s)',
  'label.effortTracking': 'Aufwandserfassung',
  'label.from': 'Von',
  'label.to': 'Bis',
  'button.addEffort': 'Aufwand hinzufügen',
  'empty.noEffortEntries': 'Noch kein Aufwand erfasst.',
  'misc.effortHelp':
    'Erfasster Aufwand wird zum summierten Aufwand pro Test addiert und durch die Anzahl bestandener Tests geteilt, um den durchschnittlichen Aufwand pro Test für Prognosen zu ermitteln. Zeiträume dürfen sich überlappen.',
  'empty.noStaleTests': 'Keine veralteten Tests — jeder Test ist kürzlich erschienen.',
  'empty.noFailingTests': 'Keine fehlerhaften Tests — der letzte Build ist grün.',
  'misc.deleting': 'Wird gelöscht…',
  'confirm.deleteStale':
    '{count} veraltete(n) Test(s) löschen? Dies entfernt auch deren Projektzuweisungen.',
  'label.failingTests': 'Fehlerhafte Tests',
  'label.skippedTests': 'Übersprungene Tests',
  'label.passingTests': 'Erfolgreiche Tests',
  'label.avgHoursPerTest': 'Ø Stunden/Test',
  'label.projectedRemainingHours': 'Verbleibende Stunden',
  'label.projectedTotalHours': 'Prognostizierte Gesamtstunden',
  'label.fteLabel': 'VZÄ',
  'label.effectiveFte': '{fte} VZÄ (von {total})',
  'label.activeProjects': 'Aktive Projekte',
  'label.projectedEnd': 'Prognostiziertes Ende (ab heute)',
  'label.project': 'Projekt',
  'label.endDate': 'Enddatum',
  'label.effortToFinish': 'Verbleibender Aufwand',
  'label.featureCompleteness': 'Funktionsvollständigkeit',
  'label.testsInProject': 'Tests im Projekt',
  'label.projectOverview': 'Projektübersicht',
  'label.totalHours': 'Gesamtstunden',
  'label.language': 'Sprache',
  'status.passed': 'Erfolgreich',
  'status.failed': 'Fehlgeschlagen',
  'status.error': 'Fehler',
  'status.skipped': 'Übersprungen',
  'status.unknown': 'Unbekannt',
  'status.featureComplete': 'Funktionsvollständig',
  'empty.noBuilds':
    'Noch keine Builds aufgezeichnet. Konfigurieren Sie den Jenkins-Webhook, um mit der Verfolgung zu beginnen.',
  'warning.staleBuildHistory': 'Seit {days} Tagen kein Build gemeldet (zuletzt am {date}).',
  'warning.staleBuildHistoryDetail':
    'Das kann auf eine defekte Test-Dashboard-Integration hindeuten - prüfen Sie den Jenkins-Webhook.',
  'empty.noTests': 'Keine Tests gefunden.',
  'empty.noUnassignedTests': 'Alle Tests sind einem Projekt zugewiesen.',
  'empty.noProjects':
    'Noch keine Projekte vorhanden. Erstellen Sie eines, um mit dem Taggen von Tests zu beginnen.',
  'empty.noTestsTagged': 'Noch keine Tests diesem Projekt zugewiesen.',
  'empty.noTestData': 'Keine Testdaten verfügbar.',
  'empty.selectProject':
    'Wählen Sie ein Projekt aus, um Details anzuzeigen und Testbudgets zu verwalten.',
  'error.failedToRemoveTest': 'Test konnte nicht entfernt werden',
  'error.failedToRemoveTests': 'Tests konnten nicht entfernt werden',
  'error.failedToCreateProject': 'Projekt konnte nicht erstellt werden',
  'error.failedToDeleteProject': 'Projekt konnte nicht gelöscht werden',
  'error.failedToFetchTests': 'Tests konnten nicht abgerufen werden',
  'error.failedToLoadTests': 'Tests konnten nicht geladen werden',
  'error.failedToUpdateSettings': 'Einstellungen konnten nicht aktualisiert werden',
  'error.failedToClearBudget': 'Budget konnte nicht gelöscht werden',
  'error.failedToSaveBudget': 'Budget konnte nicht gespeichert werden',
  'error.failedToUpdateStartDate': 'Startdatum konnte nicht aktualisiert werden',
  'error.failedToClearStartDate': 'Startdatum konnte nicht gelöscht werden',
  'error.invalidHours': 'Bitte geben Sie eine gültige Zahl für die Stunden ein',
  'error.fteMustBePositive': 'Die VZÄ-Anzahl muss größer als 0 sein',
  'error.failedToDownloadData': 'Daten konnten nicht heruntergeladen werden',
  'error.projectNotFound': 'Projekt nicht gefunden',
  'confirm.deleteProject': 'Möchten Sie dieses Projekt wirklich löschen?',
  'confirm.clearBudget': 'Budget für diesen Test löschen?',
  'component.recentBuilds': 'Aktuelle Builds',
  'component.statusDistribution': 'Statusverteilung',
  'component.testEvolution': 'Testentwicklung',
  'component.fteSettings': 'VZÄ-Einstellungen',
  'component.testEffortMaintenance': 'Test-Aufwandspflege',
  'component.addTestsToProject': 'Tests zum Projekt hinzufügen',
  'component.globalAvgEffort': 'Globaler Durchschnittlicher Testaufwand',
  'component.themeSettings': 'Design-Einstellungen',
  'theme.system': 'System',
  'theme.light': 'Hell',
  'theme.dark': 'Dunkel',
  'color.blue': 'Blau',
  'color.purple': 'Lila',
  'color.green': 'Grün',
  'color.orange': 'Orange',
  'color.pink': 'Rosa',
  'guide.title': 'So funktioniert es',
  'guide.introduction': 'Einführung',
  'guide.introText':
    'Dieses Tool hilft Teams, den Projektfortschritt durch Akzeptanztests zu verfolgen. Projekte erreichen Vollständigkeit durch das Erfüllen ihrer zugewiesenen Tests, und Enddaten werden basierend auf historischen Aufwandsdaten prognostiziert.',
  'guide.coreConcepts': 'Kernkonzepte',
  'guide.projects': 'Projekte',
  'guide.projectsDesc':
    'Ein Projekt repräsentiert ein Feature oder einen Arbeitsbereich, der verfolgt wird. Tests werden Projekten zugewiesen, um den Fortschritt zur Fertigstellung zu messen.',
  'guide.testsAndAcceptance': 'Tests & Akzeptanzkriterien',
  'guide.testsAndAcceptanceDesc':
    'Tests repräsentieren Akzeptanzkriterien. Wenn ein Test erfolgreich ist, zeigt dies an, dass eine Funktionalität abgeschlossen ist. Tests können verschiedene Zustände haben:',
  'guide.statusPassedDesc': 'Test erfolgreich ausgeführt — trägt zur Fertigstellung bei',
  'guide.statusFailedDesc': 'Test ausgeführt, aber fehlgeschlagen — Arbeit erforderlich',
  'guide.statusSkippedDesc': 'Test noch nicht implementiert — zukünftige Arbeit',
  'guide.statusErrorDesc': 'Testausführungsfehler — Untersuchung erforderlich',
  'guide.featureCompletenessTitle': 'Funktionsvollständigkeit',
  'guide.featureCompletenessDesc':
    'Die Funktionsvollständigkeit eines Projekts wird wie folgt berechnet:',
  'guide.featureCompletenessFormula':
    'Funktionsvollständigkeit = Erfolgreiche Tests / Aktivierte Tests × 100%',
  'guide.featureCompletenessNote':
    'Ein Projekt gilt als "vollständig", wenn alle aktivierten Tests erfolgreich sind (100%).',
  'guide.workflow': 'Arbeitsablauf',
  'guide.step1Title': 'Testergebnisse melden',
  'guide.step1Desc':
    'Build-Pipelines führen Akzeptanztests aus und melden Ergebnisse an den Webhook-Endpunkt mithilfe der bereitgestellten Jenkins-Shell-Skripte (parse-surefire.sh und post-test-results.sh). Ergebnisse werden stapelweise verarbeitet um Datenverlust zu vermeiden, und Statusaktualisierungen bewahren zuvor konfigurierte Budgets und Projektzuweisungen.',
  'guide.step2Title': 'Tests zu Projekten zuweisen',
  'guide.step2Desc':
    'Sobald Tests im System erscheinen, weisen Sie sie über die Konfigurationsseite Projekten zu. Dies zeigt an, dass der Test Teil des Projektumfangs ist.',
  'guide.step3Title': 'Budgetstunden festlegen',
  'guide.step3Desc':
    'Erfassen Sie optional die für jeden Test aufgewendeten Stunden. Diese Daten werden verwendet, um den durchschnittlichen Aufwand und die Projektenddatum-Prognosen zu berechnen.',
  'guide.step4Title': 'Fortschritt verfolgen',
  'guide.step4Desc':
    'Überwachen Sie den Projektfortschritt im Projekt-Dashboard. Wenn Tests erfolgreich sind, steigt der Fertigstellungsgrad und das prognostizierte Enddatum passt sich an.',
  'guide.projectionFormulas': 'Prognoseformeln',
  'guide.avgHoursTitle': 'Durchschnittliche Stunden pro Test',
  'guide.avgHoursDesc':
    'Eine globale Kennzahl, die über alle Tests im System berechnet wird, nicht pro Projekt:',
  'guide.avgHoursFormula':
    'Durchschnittliche Stunden = Gesamte Budgetstunden / Anzahl nicht-übersprungener Tests',
  'guide.avgHoursNote':
    'Alle nicht-übersprungenen Tests werden im Nenner verwendet. Dies ist eine systemweite Kennzahl, die den organisationsweiten Durchschnittsaufwand pro Test widerspiegelt.',
  'guide.projectedTotalTitle': 'Prognostizierte Gesamtstunden',
  'guide.projectedTotalDesc':
    'Schätzt den Gesamtaufwand einschließlich prognostiziertem Aufwand für verbleibende übersprungene Tests:',
  'guide.projectedTotalFormula':
    'Prognostizierter Gesamtaufwand = Gesamte Budgetstunden + (Durchschnittliche Stunden × Anzahl übersprungener Tests)',
  'guide.projectedTotalNote':
    'Nur übersprungene (noch nicht begonnene) Tests werden prognostiziert. Bekannter Aufwand aus budgetierten Tests wird unverändert übernommen.',
  'guide.endDateTitle': 'Enddatum-Prognose',
  'guide.endDateDesc':
    'Enddaten werden mittels einer iterativen Simulation berechnet, die die VZÄ-Umverteilung bei Projektabschluss berücksichtigt:',
  'guide.dailyCapacityFormula':
    'Tägliche Kapazität pro Projekt = 7,42 Stunden × VZÄ-Anzahl / Aktuelle aktive Projekte',
  'guide.daysNeededFormula':
    'Bei Projektabschluss wird der VZÄ-Anteil auf verbleibende Projekte umverteilt',
  'guide.endDateFormula': 'Enddatum = Simulation aller Projektabschlüsse über die Zeit',
  'guide.endDateNote':
    'Die Simulation teilt VZÄ gleichmäßig auf aktive Projekte auf. Wenn kürzere Projekte zuerst abgeschlossen werden, erhalten die verbleibenden Projekte mehr Kapazität und beschleunigen sich. Dies liefert genauere Enddaten als eine einfache statische Aufteilung.',
  'guide.quickLinks': 'Schnelllinks',
  'guide.viewTestTrends': 'Testausführungstrends anzeigen',
  'guide.monitorCompletion': 'Projektfortschritt überwachen',
  'guide.manageProjects': 'Projekte verwalten und Tests zuweisen',
  'guide.inspectFailures': 'Die Fehler des letzten Builds untersuchen',
  'misc.creating': 'Wird erstellt...',
  'misc.saving': 'Wird gespeichert...',
  'misc.assigning': 'Wird zugewiesen...',
  'misc.loadingProject': 'Projekt wird geladen...',
  'misc.version': 'Version {version}',
  'misc.fteHelp':
    'Die VZÄ-Anzahl wird zur Berechnung von Projektenddaten verwendet (37,1 Stunden/Woche pro VZÄ)',
  'misc.testEffortDesc':
    'Erfassen Sie Aufwandsstunden und Pufferprozentsätze für Tests über alle Projekte hinweg.',
  'misc.removeFromProject': 'Aus Projekt entfernen',
  'misc.downloading': 'Wird heruntergeladen...',
  'misc.globalAvgHelp':
    'Systemweiter Durchschnitt, berechnet als Gesamtbudgetstunden geteilt durch alle nicht-übersprungenen Tests. Wird für alle Prognosen verwendet.',
}

export const translations: Record<Language, TranslationRecord> = { en, de }
